import { useState } from "react";
import { X, Pause, CalendarBlank } from "@phosphor-icons/react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";

// Modal de pausa de anúncio: indefinida ou agendada (de/até). V12.4
export default function PauseListingModal({ listing, onClose, onDone }) {
  const [mode, setMode] = useState("indefinite"); // indefinite | scheduled
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [busy, setBusy] = useState(false);
  const today = new Date().toISOString().slice(0, 10);

  const submit = async () => {
    if (mode === "scheduled" && (!start || !end)) {
      toast.error("Escolha as datas de início e fim da pausa.");
      return;
    }
    setBusy(true);
    try {
      const body = mode === "scheduled"
        ? { mode: "scheduled", start_date: start, end_date: end }
        : { mode: "indefinite" };
      await api.post(`/listings/${listing.id}/pause`, body);
      toast.success(mode === "scheduled" ? "Pausa agendada com sucesso!" : "Anúncio pausado — não aparece na busca.");
      onDone?.();
      onClose?.();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/50 flex items-end sm:items-center justify-center p-0 sm:p-4 pb-safe" data-testid="pause-modal">
      <div className="bg-white w-full sm:max-w-md rounded-t-2xl sm:rounded-2xl p-5 space-y-4">
        <div className="flex items-center justify-between">
          <h2 className="font-heading font-black text-lg flex items-center gap-2"><Pause size={20} weight="fill" className="text-amber-500" /> Pausar anúncio</h2>
          <button onClick={onClose} className="p-1 text-slate-400" data-testid="pause-modal-close"><X size={22} /></button>
        </div>
        <p className="text-xs text-slate-500 line-clamp-1">{listing.title}</p>

        <button
          onClick={() => setMode("indefinite")}
          className={`w-full text-left p-3 rounded-xl border-2 ${mode === "indefinite" ? "border-[#004E98] bg-[#004E98]/5" : "border-slate-200"}`}
          data-testid="pause-mode-indefinite">
          <div className="font-bold text-sm">Pausar indefinidamente</div>
          <div className="text-[11px] text-slate-500">O anúncio some da busca até você reativar manualmente.</div>
        </button>

        <button
          onClick={() => setMode("scheduled")}
          className={`w-full text-left p-3 rounded-xl border-2 ${mode === "scheduled" ? "border-[#FF6B35] bg-[#FF6B35]/5" : "border-slate-200"}`}
          data-testid="pause-mode-scheduled">
          <div className="font-bold text-sm flex items-center gap-1"><CalendarBlank size={15} weight="bold" /> Pausar por um período</div>
          <div className="text-[11px] text-slate-500">Reativa sozinho no fim do período (ideal para viagens/manutenção).</div>
          {mode === "scheduled" && (
            <div className="grid grid-cols-2 gap-2 mt-3" onClick={(e) => e.stopPropagation()}>
              <label className="block">
                <span className="text-[10px] uppercase font-bold text-slate-500">Início</span>
                <input type="date" min={today} value={start} onChange={(e) => setStart(e.target.value)} className="aj-input text-sm" data-testid="pause-start-date" />
              </label>
              <label className="block">
                <span className="text-[10px] uppercase font-bold text-slate-500">Fim</span>
                <input type="date" min={start || today} value={end} onChange={(e) => setEnd(e.target.value)} className="aj-input text-sm" data-testid="pause-end-date" />
              </label>
            </div>
          )}
        </button>

        <button onClick={submit} disabled={busy} className="btn-primary w-full disabled:opacity-50" data-testid="pause-confirm-btn">
          {busy ? "Salvando..." : "Confirmar pausa"}
        </button>
      </div>
    </div>
  );
}
